"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.email.contacts': 'Contatti',
    'whatsapp.email.noContacts': 'Nessun contatto email trovato.',
    'whatsapp.email.loadFailed': 'Impossibile caricare i contatti email.',
    'whatsapp.email.stats.contacts': 'Contatti',
    'whatsapp.email.stats.total': 'Totale',
    'whatsapp.email.trackLogs': 'Log di tracciamento',
    'whatsapp.email.noLogs': 'Nessun log di tracciamento ancora.',
};
